import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import DownloadHourlyWageReportButton from './components/DownloadHourlyWageReportButton';
import withToggle from '../../../common/hoc/withToggle';
import { calculateHourlyWagesEnabled } from '../../timeTracker/selectors';
import {
  downloadShopHourlyWageReport,
  downloadBrandHourlyWageReport,
} from '../actions';

const mapStateToProps = state => ({
  calculateHourlyWagesEnabled: calculateHourlyWagesEnabled(state),
  shopAction: downloadShopHourlyWageReport,
  brandAction: downloadBrandHourlyWageReport,
});

export default compose(
  connect(mapStateToProps),
  branch(
    props => !props.calculateHourlyWagesEnabled,
    renderNothing,
  ),
  withToggle('modal'),
)(DownloadHourlyWageReportButton);
